import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { SubscriptionFacadeService } from '../../services/subscription-facade.service';

import { ReferenceDao } from '@app/dao/reference/reference.dao';
import { SwisslifeLocationService } from '@app/services/swisslife-location.service';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

import { Validators } from '@angular/forms';
import { take } from 'rxjs';
@Component({
    selector: 'owner-tax-residence',
    templateUrl: './owner-tax-residence.component.html',
    styleUrls: ['./owner-tax-residence.component.scss'],
    standalone: false
})
export class OwnerTaxResidenceComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  countries = [];
  hasSwisslifeProduct: boolean = false;

  constructor(
    private referenceDao: ReferenceDao,
    protected formConstructor: PrFormConstructor,
    private cd: ChangeDetectorRef,

    private subscriptionFacade: SubscriptionFacadeService,
    private swisslifeLocation: SwisslifeLocationService,
  ) {
    super(formConstructor);
  }
  ngOnInit() {
    const pledge = this.subscriptionFacade.getPledge();
    this.referenceDao
      .getCountries()
      ?.pipe(take(1))
      .subscribe(countries => {
        this.countries = countries;
      });
    this.hasSwisslifeProduct =
      this.swisslifeLocation.hasSwisslifeProduct(pledge);
    this.subscriptionFacade.initForm(this);
    this.owners.controls.forEach((ownerControl, index) => {
      ownerControl.valueChanges.subscribe(owner => {
        if (
          this.hasSwisslifeProduct &&
          owner?.taxResidence &&
          !this.FR_VALUES.includes(owner.taxResidence)
        ) {
          this.owners.controls[index]
            .get('dateNonResidenceFiscaleEnFrance')
            .setValidators([Validators.required]);
          this.owners.controls[index]
            .get('dateNonResidenceFiscaleEnFrance')
            .updateValueAndValidity();
        } else {
          this.owners.controls[index]
            .get('dateNonResidenceFiscaleEnFrance')
            .setValidators([Validators.nullValidator]);
          this.owners.controls[index]
            .get('dateNonResidenceFiscaleEnFrance')
            .updateValueAndValidity();
        }
      });
    });
  }

  onSubmit() {
    this.form.markAsDirty();
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }

  isNotFranceTaxResidence(owner: any): boolean {
    const { taxResidence = 'FR' } = owner || {};
    return !this.FR_VALUES.includes(taxResidence);
  }
}
